import { InjectionToken } from '@angular/core';

import { BuildEnvironment } from '@shared/models';

export interface AppConfig {
  name: BuildEnvironment;
  apiHost: string;
  production: boolean;
}

export const APP_ENV_CONFIG = new InjectionToken<AppConfig>('Application Environment Config');

export const getEnvironment = (host: string = window.location.host): AppConfig => {
  switch (host) {
    case 'linx.rocketkor.net':
    case 'app.cateno.ai':
      return {
        name: 'production',
        production: true,
        apiHost: 'https://api.rocketkor.net',
      };
    case 'workflow.salttreasury.com':
      return {
        name: 'production',
        production: true,
        apiHost: 'https://api.salttreasury.com',
      };
    case 'linx.sandbox.rocketkor.net':
    case 'app.sandbox.cateno.ai':
      return {
        name: 'sandbox',
        production: true,
        apiHost: 'https://api.sandbox.rocketkor.net',
      };
    case 'workflow.sandbox.salttreasury.com':
      return {
        name: 'sandbox',
        production: true,
        apiHost: 'https://api.sandbox.salttreasury.com',
      };
    case 'linx.staging.rocketkor-nonprod.net':
    case 'app.staging.cateno.ai':
      return {
        name: 'staging',
        production: false,
        apiHost: 'https://api.staging.rocketkor-nonprod.net',
      };
    case 'workflow.staging.salttreasury.com':
      return {
        name: 'staging',
        production: false,
        apiHost: 'https://api.staging.salttreasury.com',
      };
    case 'rocketkor-qa-linx-frontend.web.app':
    case 'rocketkor-qa-linx-frontend.firebaseapp.com':
    case 'linx.qa.rocketkor-nonprod.net':
    case 'app.qa.cateno.ai':
      return {
        name: 'qa',
        production: false,
        apiHost: 'https://api.qa.rocketkor-nonprod.net',
      };
    case 'workflow.qa.salttreasury.com':
      return {
        name: 'qa',
        production: false,
        apiHost: 'https://api.qa.salttreasury.com',
      };
    case 'rocketkor-dev-linx-frontend.web.app':
    case 'rocketkor-dev-linx-frontend.firebaseapp.com':
    case 'linx.dev.rocketkor-nonprod.net':
      return {
        name: 'develop',
        production: false,
        apiHost: 'https://api.dev.rocketkor-nonprod.net',
      };
    default:
      return {
        name: 'qa',
        production: false,
        apiHost: 'https://api.qa.rocketkor-nonprod.net',
      };
  }
};
